export default __webpack_public_path__ + "static/accents-whiteboard-light-021b7f9bb79d5907304b6c65676954341db17e1779c51e533d20a88e921679d7.png";